import React, { Component } from 'react';

export default class Config extends Component {
  render() {
    return (
      <h2 data-testid="settings-title">Configurações</h2>
    );
  }
}
